import {fetchAuthTeam, teamsQueryOptions} from '@blesk-frontend/api';
import {useBleskAuth} from '@blesk-frontend/auth';
import {cn} from '@blesk-frontend/ui';
import {useQuery, useQueryClient} from '@tanstack/react-query';
import {Outlet, useLocation} from '@tanstack/react-router';
import {useEffect, useMemo} from 'react';
import {AppSidebar} from '@/components/index';
import {changedTeamHintKey, teamMemberInviteHintKey} from '../features/team';

export const AppLayout = () => {
  const location = useLocation();
  const isEditor = useMemo(() => location.pathname.includes('/edit'), [location]);

  const queryClient = useQueryClient();
  const {teamId, updateToken} = useBleskAuth();
  const {data: teams} = useQuery(teamsQueryOptions());

  const currentTeam = useMemo(() => {
    return teams?.find((team) => team.id === teamId);
  }, [teams, teamId]);

  useEffect(() => {
    if (teamId && !currentTeam && !!teams?.length) {
      const changeTeam = async () => {
        const {accessToken} = await fetchAuthTeam({teamId: teams?.at(0)?.id as string});
        localStorage.setItem(changedTeamHintKey, 'true');
        localStorage.setItem(teamMemberInviteHintKey, 'true');
        updateToken(accessToken);
        queryClient.clear();
      };

      changeTeam();
    }
  }, [teamId, currentTeam, teams, updateToken, queryClient]);

  return (
    <div className={cn('min-h-screen', !isEditor && 'grid grid-cols-[240px_1fr]')}>
      {!isEditor && (
        <div className="sticky top-0 h-screen w-60 shrink-0 border-r bg-bg-secondary">
          <AppSidebar />
        </div>
      )}
      <div className="size-full min-h-screen min-w-[768px] p-10">
        <Outlet />
      </div>
    </div>
  );
};
